'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TABLE_COLUMNS, _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _constants = require('../../constants');

var _mainApplications = require('../page-case/main-applications');

var _BaseApplicationsPage = require('../base/BaseApplicationsPage');

var _BaseApplicationsPage2 = _interopRequireDefault(_BaseApplicationsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_MODELS = _constants.AppConstants.APPLICATION_MODELS;


var TABLE_COLUMNS = (_TABLE_COLUMNS = {}, _defineProperty(_TABLE_COLUMNS, APPLICATION_MODELS.LEGAL_FUNDING.model, _mainApplications.REJECTED_LEGAL_APPLICATION_COLUMNS), _defineProperty(_TABLE_COLUMNS, APPLICATION_MODELS.MEDICAL.model, _mainApplications.REJECTED_MEDICAL_APPLICATION_COLUMNS), _TABLE_COLUMNS);

var RejectedApplicationsPage = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'FunderStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(RejectedApplicationsPage, _Component);

  function RejectedApplicationsPage(props) {
    _classCallCheck(this, RejectedApplicationsPage);

    var _this = _possibleConstructorReturn(this, (RejectedApplicationsPage.__proto__ || Object.getPrototypeOf(RejectedApplicationsPage)).call(this, props));

    _initDefineProp(_this, 'columns', _descriptor, _this);

    _this.columns = TABLE_COLUMNS[props.FunderStore.defaultApplicationType];
    return _this;
  }

  _createClass(RejectedApplicationsPage, [{
    key: 'setColumns',
    value: function setColumns(selected) {
      this.columns = TABLE_COLUMNS[selected];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ApplicationStore = _props.ApplicationStore,
          rejectedApplicationsPage = _props.UiStore.rejectedApplicationsPage;

      return _react2.default.createElement(_BaseApplicationsPage2.default, {
        fetchCounts: ApplicationStore.fetchRejectedCounts,
        fetchData: ApplicationStore.fetchRejected,
        pageName: 'rejected-applications',
        pageStore: rejectedApplicationsPage,
        pageTitle: 'Rejected Applications',
        setColumns: this.setColumns,
        SidebarComponent: _mainApplications.RejectedApplicationsSidebar,
        tableColumns: (0, _mobx.toJS)(this.columns),
        tableTitle: 'Rejected Applications'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RejectedApplicationsPage;
}(_react.Component), _class3.propTypes = {
  ApplicationStore: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setColumns', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'setColumns'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = RejectedApplicationsPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_MODELS, 'APPLICATION_MODELS', '/app/src/components/page-applications-rejected/RejectedApplicationsPage.js');
  reactHotLoader.register(TABLE_COLUMNS, 'TABLE_COLUMNS', '/app/src/components/page-applications-rejected/RejectedApplicationsPage.js');
  reactHotLoader.register(RejectedApplicationsPage, 'RejectedApplicationsPage', '/app/src/components/page-applications-rejected/RejectedApplicationsPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-applications-rejected/RejectedApplicationsPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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